export const KNOW_MORE = "En savoir +";
export const SERVICES = "Services";
export const SEARCH_SKIP = 0;
export const SEARCH_LIMIT = 60;
